<template>
  <section>
    <div class="form-header">
      <h1>Unlock your Account</h1>
      <br>
      <h3>Step 1: Verify your information</h3>
    </div>
    <hr>
    <div>
      <b-form @submit="onSubmit" v-if="show" autocomplete="off">
        <div id="rules">
          <p>{{ text }}</p>
        </div>
        <br>
        <b-form-group id="userIDLabel">
          <b-form-input id="userID"
                        type="text"
                        v-model="userId"
                        required
                        placeholder="Username / Employee Number">
          </b-form-input>
          <br>

          <CommonReCaptcha
              ref="captchaRef"
              @verify="saveCaptcha"
          />

        </b-form-group>
        <div>
          <b-button type="submit" variant="primary">Next</b-button>
          <app-spinner v-if="spinner"></app-spinner>
        </div>
      </b-form>

      <b-modal ref="alertModal" :title="alertHeader" :ok-only="true">
        <p class="my-4">{{ alertText }}</p>
        <template #footer>
          <div class="w-100">
            <b-button v-if="alertNav === 'home'" size="sm" class="float-end" variant="primary" @click="navigateHome()">
              Okay
            </b-button>
            <b-button v-if="alertNav === 'resetPassword'" size="sm" class="float-end" variant="primary" @click="navigateResetPassword()">
              Okay
            </b-button>
            <b-button v-if="alertNav === 'here'" size="sm" class="float-end" variant="primary" @click="navigateHere()">
              Okay
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </section>
</template>

<script>
import { useFormDataStore } from '../../stores/formData'
import { useLocalApiStore } from '../../stores/localApi'
import { useGoogleStore } from '../../stores/google'
import { useFormOrchestrationStore } from '../../stores/formOrchestration'
import Spinner from '../Spinner.vue'
import CommonReCaptcha from '../../components/CommonReCaptcha.vue' // ADDED
import clientServices from '../../clientServices.js'

export default {
  name: 'FormULA1',
  components: {
    'app-spinner': Spinner,
    CommonReCaptcha // ADDED
  },
  data() {
    return {
      // widgetId is removed as child handles it
      captchaResponse: '',
      alertHeader: '',
      alertText: '',
      alertNav: 'here',
      text: 'Please enter your username or employee number:',
      show: true,
      spinner: false
    }
  },
  computed: {
    getSiteKey() {
      const g = useGoogleStore()
      return g.getSiteKey
    },
    getSessionKey() {
      const fd = useFormDataStore()
      return fd.getSessionKey
    },
    userId: {
      get() { const fd = useFormDataStore(); return fd.formData.userId },
      set(value) { const fd = useFormDataStore(); fd.updateFormDataUserId(value) }
    }
  },
  methods: {
    updateCurrentForm(formName) { const fo = useFormOrchestrationStore(); return fo.updateCurrentForm(formName) },
    clearData() { const fd = useFormDataStore(); return fd.clearData() },
    setSessionKey(k) { const fd = useFormDataStore(); return fd.setSessionKey(k) },
    accountLookup(p) { const api = useLocalApiStore(); return api.accountLookup(p) },
    newSessionKey() { const api = useLocalApiStore(); return api.newSessionKey() },
    checkCaptcha(params) { const g = useGoogleStore(); return g.checkCaptcha(params) },

    // REPLACED: initReCaptcha is gone because the child component handles it auto-magically

    saveCaptcha(token) {
      this.captchaResponse = token
    },
    resetCaptcha() {
      // Calling the reset method inside CommonReCaptcha
      if (this.$refs.captchaRef) {
        this.$refs.captchaRef.reset();
      }
      this.captchaResponse = '';
    },
    async onSubmit(evt) {
      evt.preventDefault();
      this.spinner = true;

      if (this.captchaResponse !== '') {
        let captchaParams = {
          params: {
            sessionKey: this.getSessionKey,
            response: this.captchaResponse
          }
        };

        let captchaValidation = await this.checkCaptcha(captchaParams);
        if (captchaValidation === true) {
          let parameters = {
            userId: this.userId,
            sessionKey: this.getSessionKey,
            requestType: 'unlockAccount' // Note: Ensure this matches your API requirements
          };
          let accountData = await this.accountLookup(parameters);

          if (accountData.result === 'FAILURE' || accountData.result === 'Failure') {
            if (accountData.resultMessage === 'Invalid Session Encountered') {
              // refresh the global session and persist it to the form data store
              const newKey = await this.newSessionKey();
              this.setSessionKey(newKey);
              this.resetCaptcha();
              this.spinner = false;
              this.showAlertModal('Session Refreshed', 'Your session expired and has been renewed. Please try again.', 'here')
              return;
            } else {
              this.spinner = false;
              this.showAlertModal('Request Failure', accountData.resultMessage || 'General Failure', 'home')
            }
          } else {
            const fd = useFormDataStore();
            fd.updateValidationDevices(accountData.data.validationDevices);
            this.spinner = false;
            this.updateCurrentForm('FormULA2')
          }
        } else {
          this.spinner = false;
          this.showAlertModal('Error', 'Verification failed. Please contact the Help Desk.', 'home')
        }
      } else {
        this.spinner = false;
        this.showAlertModal('Error', 'Please validate you\'re not a robot and try again.', 'here')
      }
    },
    showAlertModal(header, text, nav) {
      this.alertNav = nav;
      this.alertHeader = header;
      this.alertText = text;
      this.$refs.alertModal.show()
    },
    hideAlertModal() {
      this.resetCaptcha();
      this.$refs.alertModal.hide()
    },
    navigateHome() {
      this.hideAlertModal();
      this.clearData();
      this.$router.push('/')
    },
    navigateResetPassword() {
      this.hideAlertModal();
      this.clearData();
      this.$router.push('/resetPassword')
    },
    navigateHere() {
      this.resetCaptcha();
      this.hideAlertModal()
    }
  },
  async mounted() {
    // initReCaptcha call removed
  },
  async created() {
    let sessionKey = this.getSessionKey;
    if (sessionKey == null || sessionKey.length < 12) {
      sessionKey = await clientServices.getSessionKey();
      this.setSessionKey(sessionKey);
    }
  }
}
</script>

<style scoped>
/* Styles remain the same */
.form-header {
  display: flex;
  flex-direction: column; /* This stacks h1 and h3 vertically */
  justify-content: flex-start;
  align-items: flex-start; /* Aligns text to the left */
  margin: 25px 0;
  width: 100%;
}
h1 { font-weight: bold; color: #000; }
h3 { color: #4A4A4A; }
form { display: flex; flex-direction: column; }
.form-group {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  font-weight: bold;
  color: #000;
}
button {
  margin: 15px 0px;
  background-color: #5487BA;
  width: 100px;
  font-weight: bold;
}
button:hover { background-color: #123A5D; }
.form-control { background-color: #FFF; }
#rules {
  background-color: #f5f5f5;
  width: 100%;
  font-size: 1rem;
  padding: 10px;
  text-align: left;
}
</style>